import {convertRemToPixels} from '~/common/utils';

interface GetResposivelySizeToHintScrollOptions {
  numVisible: number;
  itemGap?: number;
  itemGapUnits?: 'rem' | 'px';
  containerSize: number | string;
}

export const getResponsiveSizeToHintScroll = (
  options: GetResposivelySizeToHintScrollOptions
): string => {
  let size: string;
  if (options.itemGap) {
    // Account for any gap between elements in the container
    size = `calc((${options.containerSize} - ${(options.itemGapUnits === 'rem' ? convertRemToPixels(options.itemGap) : options.itemGap) * options.numVisible}px) / ${options.numVisible + 0.5})`;
  } else {
    size = `calc(${options.containerSize} / ${options.numVisible + 0.5})`;
  }
  return size;
};
